const getProjectCopy = {
  projectID: '',
  isactive: true,
  isapproved: true,
};
export default getProjectCopy;
